import { GridColumnHeaderParams, GridValueFormatterParams } from "@mui/x-data-grid-pro";

/**
 * Lookup a field label using the field's name.
 * @param fieldLabels A map of field name to field label.
 * @returns A field label.
 */
export function fieldLabelFormat(fieldLabels: Record<string, string>): (params: GridColumnHeaderParams) => string {
  return function doRender(params: GridColumnHeaderParams): string {
    return fieldLabels[params.field] ?? params.field;
  }
}

/**
 * Lookup a value label using the field's value.
 * @param valueLabels A map of field value to field label.
 * @returns A value label.
 */
export function valueLabelsFormat(valueLabels: Record<string, Record<string,string>>): (params: GridValueFormatterParams) => string {
  return function doFormat(params: GridValueFormatterParams): string {
    const fieldValueLabels: Record<string, string> = valueLabels[params.field];
    return fieldValueLabels[params.value] ?? params.value;
  }
}

// Fields returned from the API could be dynamically mapped to columns by using their type.
// const columnRenderTypes = {
//   // This could be an array of objects if we wanted to extend it, such as setting a default
//   boolean: [
//     "checkbox",           // [x]
//     "text"                // True | False
//   ],
//   decimal: [
//     "currency",           // $123.45
//     "distributionBar",   // [|||||   ]
//     "number",             // 123.456
//     "percent"             // 12.3%
//   ],
//   integer: [
//     "number"              // 123,456
//   ],
//   keyword: [
//     "chip"                // (One)
//   ],
//   keywords: [
//     "chips"               // (One) (Two) (Three)
//   ],
//   latitude_longitude: [
//     "chipTuple"          // (12.3, 45.6)
//   ],
//   text: [
//     "text"                // "Render as-is"
//   ],
//   timestamp: [
//     "date",               // 2024-04-30
//     "dateTime"           // 2024-04-30, 10:30 AM
//   ]
// }